import _ from '@centerhealth/common/lodash';
import { UserOrSub } from '@centerhealth/types';
import { MeterTypes, MeterTags, IDeviceInfo, DeviceCategories } from '../interfaces';
import { DEVICES_CONSTANT } from '../constants';

export const getDeviceInfo = (meterTypeOrTag: MeterTypes | MeterTags): IDeviceInfo | undefined =>
  _.find(
    DEVICES_CONSTANT,
    (dev) =>
      dev.meterType.toLowerCase() === meterTypeOrTag.toLowerCase() ||
      dev.meterTag.toLowerCase() === meterTypeOrTag.toLowerCase()
  );

export const getDeviceTag = (userOrSub: UserOrSub): MeterTags => {
  let meterType: MeterTypes;
  _.forEach(userOrSub.devices, (arr, deviceType) => {
    if (arr && arr.length > 0) {
      meterType = deviceType as MeterTypes;
    }
  });
  return getDeviceInfo(meterType)!.meterTag;
};

export const getDevicesByCategory = (category: DeviceCategories): IDeviceInfo[] =>
  _.filter(DEVICES_CONSTANT, (dev) => dev.category === category);

export const metersEventSources = _.map(DEVICES_CONSTANT, 'eventSource');
